(function ($) {
  function shouldShowFloatingButtons() {
    if (window.location.pathname.indexOf("/civicrm/") !== -1) return false;
    if (document.body.classList.contains("page-node-type-webform"))
      return false;

    //If #CHS_chat_btn exists on the page, and it is visible (not display none)
    let chatBtn = $("#CHS_chat_btn").is(":visible");
    if (chatBtn) return false;

    let threshold = Math.min(300, window.innerHeight * 0.4);
    return window.scrollY >= threshold;
  }

  function updateFloatingButtons() {
    let floatingActions = document.querySelector(".floating-actions");
    if (!floatingActions) return;

    floatingActions.classList.toggle("show", shouldShowFloatingButtons());
  }

  document.addEventListener("DOMContentLoaded", function () {
    updateFloatingButtons();
    window.addEventListener("scroll", updateFloatingButtons, { passive: true });
  });
})(jQuery);
